import { History as HistoryIcon, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

/**
 * Lists past roster snapshots and lets the admin revert to any of them.
 * The 'revert' action snapshots the current state first, so reverts are reversible.
 */
export const HistoryDialog = ({ open, onOpenChange, history, loading, revertingId, onRevert }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-lg" data-testid="history-dialog">
      <DialogHeader>
        <DialogTitle className="text-xl tracking-tight font-bold flex items-center gap-2">
          <HistoryIcon className="w-5 h-5 text-[#002FA7]" /> Generation History
        </DialogTitle>
      </DialogHeader>
      <div className="mt-2 -mx-6 px-6">
        <p className="text-xs text-zinc-500 dark:text-zinc-400 mb-4">
          The last 10 saved versions are kept. Click "Revert" to restore an older roster — your current entries will be snapshotted first so revert is itself reversible.
        </p>
        {loading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="w-6 h-6 animate-spin text-zinc-400" />
          </div>
        ) : history.length === 0 ? (
          <div className="text-center py-10 text-sm text-zinc-500" data-testid="history-empty">
            No previous generations saved yet. Each time you generate or regenerate, the prior roster is saved here automatically.
          </div>
        ) : (
          <div className="divide-y divide-zinc-100 dark:divide-zinc-800 border border-zinc-200 dark:border-zinc-800 rounded max-h-[420px] overflow-y-auto">
            {history.map((v) => (
              <div
                key={v.version_id}
                className="p-3 flex items-center justify-between gap-3 hover:bg-zinc-50 dark:hover:bg-zinc-800/50"
                data-testid={`history-version-${v.version_id}`}
              >
                <div className="min-w-0">
                  <p className="text-sm font-medium text-zinc-900 dark:text-zinc-100 truncate">
                    {v.label || "Snapshot"}
                  </p>
                  <p className="text-xs text-zinc-500 dark:text-zinc-400 tabular-nums">
                    {new Date(v.created_at).toLocaleString()} · {v.entry_count || 0} entries
                  </p>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  disabled={revertingId === v.version_id}
                  onClick={() => onRevert(v.version_id)}
                  data-testid={`revert-${v.version_id}`}
                >
                  {revertingId === v.version_id ? (
                    <><Loader2 className="w-3 h-3 mr-1 animate-spin" /> Reverting…</>
                  ) : (
                    <>Revert</>
                  )}
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
